/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './observe-content';

/**
 * @deprecated Use CdkObserveContent
 * @deletion-target 6.0.0
 */
export {CdkObserveContent as ObserveContent} from './observe-content';
